/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Empty_StateInputs */



/**
* | output |
* | --- |
* | "No terms yet. Click \"Add Term\" to create your first term." |
*
* @param {Knp_Terms_Empty_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_empty_state = /** @type {((inputs?: Knp_Terms_Empty_StateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Empty_StateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun terme pour le moment. Cliquez sur « Ajouter un terme » pour créer votre premier terme.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Termine. Klicken Sie auf „Termin hinzufügen“, um Ihren ersten Termin zu erstellen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun termine ancora. Fai clic su \"Aggiungi termine\" per creare il tuo primo termine.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пока нет свободных сроков. Нажмите «Добавить срок», чтобы создать свой первый срок.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no hay términos. Haz clic en \"Añadir término\" para crear el primero.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("暂无条款。点击“添加条款”创建您的第一个条款。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("まだ用語がありません。最初の用語を作成するには、「用語を追加」をクリックしてください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अभी तक कोई टर्म नहीं है। अपना पहला टर्म बनाने के लिए \"टर्म जोड़ें\" पर क्लिक करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ainda não existem termos. Clique em \"Adicionar termo\" para criar seu primeiro termo.")
	return /** @type {LocalizedString} */ ("No terms yet. Click \"Add Term\" to create your first term.")
});